import React from 'react'

import {
  ClearIndicatorProps as DefaultProps,
  GroupBase,
  components,
} from 'react-select'

import { IconNotebook, SelectOptionInterface } from '@customTypes'
import { Icon } from '_components/icon'
import { palette } from '_styles/variables'

export const getClearIndicator = (title?: string, icon?: IconNotebook) => {
  const ClearIndicator = React.memo(
    <
      Opt extends SelectOptionInterface,
      IsMulti extends boolean,
      Group extends GroupBase<Opt>
    >(props: DefaultProps<Opt, IsMulti, Group>) =>
       (
        <components.ClearIndicator {...props}>
          <Icon
            icon={icon ?? "x-circle"}
            size="1.25rem"
            title={title}
            aria-label="Clear select"
            color={palette.neutral['grey-bbbdbf']}
          />
        </components.ClearIndicator>
      )
  )

  ClearIndicator.displayName = 'ClearIndicator'

  return ClearIndicator as typeof components.ClearIndicator
}
